import { OPTLY_FEATURE } from '../reducers/index';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOptly from '@optly/store/reducers';

const getOptlyState =
  createFeatureSelector<fromOptly.OptlyState>(OPTLY_FEATURE);

export const getExperiments = createSelector(
  getOptlyState,
  (state) => state.experiments?.data || []
);

export const isExperimentActive = createSelector(
  getExperiments,
  (experiments, { props }) => !!experiments.includes(props)
);
